<template>
  <div class="product-tags">
    <v-chip v-for="item in coloredItems" :key="item.text" label small class="product-tag mr-2 mb-2" :color="item.color">
      <!-- <span class="text-muted">{{ item.text }}</span> -->
      {{ item.text }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'ProductTags',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      colors: ['#E2F2A1', '#EACEF7', '#CEEBF7', '#FFD4D4'],
    };
  },
  computed: {
    coloredItems() {
      return this.items.reduce((acc, item, index) => {
        const previousColors = [index > 0 ? acc[index - 1].color : -1, index > 1 ? acc[index - 2].color : -1];
        let colorIndex = Math.floor(Math.random() * this.colors.length);
        while (previousColors.includes(this.colors[colorIndex])) {
          colorIndex = Math.floor(Math.random() * this.colors.length);
        }
        return [
          ...acc,
          {
            text: item,
            color: this.colors[colorIndex],
          },
        ];
      }, []);
    },
  },
};
</script>

<style lang="scss" scoped>
.product-tag {
  padding: 1px 5px;
  border-radius: 4px !important;
  color: $light-textColor;
}
</style>
